import { useState } from 'react'
import { supabase } from '../lib/supabase'

// Creates a shopping_lists row pre-completed (completed_at = now()) so
// useUnpackList — which filters completed_at IS NULL — won't pick it up
// alongside planned trips. unpacked_at stays null until useFinishUnpack
// runs successfully, which is also what keeps usePendingUnpack honest.
export function useStartSpontaneousTrip() {
  const [loading, setLoading] = useState(false)

  async function start(householdId: string): Promise<string | null> {
    if (!householdId) return null
    setLoading(true)

    try {
      const now = new Date().toISOString()
      const { data, error } = await supabase
        .from('shopping_lists')
        .insert({
          household_id: householdId,
          generated_at: now,
          completed_at: now,
        })
        .select('id')
        .single()

      if (error || !data) {
        console.error('[useStartSpontaneousTrip] create failed:', error)
        return null
      }
      return data.id
    } finally {
      setLoading(false)
    }
  }

  return { start, loading }
}
